import { Skeleton, styled } from '@mui/material'

export const HeaderContainer = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
`

export const TitleLabel = styled(Skeleton)`
  width: ${({ theme }) => theme.spacing(20)};
  height: ${({ theme }) => theme.spacing(3)};
`

export const CircularSkeleton = styled(Skeleton)`
  width: ${({ theme }) => theme.spacing(5)};
  height: ${({ theme }) => theme.spacing(5)};
  border-radius: 50%;
`
